export default "__VITE_ASSET__a6b5c7b0__"